interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodySmallMedium = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-sm font-medium leading-5 ${className}`}>
            {children}
        </p>
    );
};